import { type FC, type ReactNode } from 'react';

import { useHelpFetcherConnected, useHelpSlice } from '../../store';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { useIsLargerThanWide } from '../../styles/hooks/media';
import { PassiveComponentContext } from '../context';
import { ErrorBoundary } from '../errorBoundary/ErrorBoundary';
import { Loader } from '../loader';
import { ModalPages } from '../modal/modalPages/ModalPages';

import { HelpErrorMessage } from './errorMessage/HelpErrorMessage';
import { HelpNavConnected } from './nav/HelpNavConnected';
import { HelpPageConnected } from './page/HelpPageConnected';

export interface HelpConnectedProps {
  inNavDrawer?: boolean;
}

export const HelpConnected: FC<HelpConnectedProps> = ({ inNavDrawer }) => {
  const isError = useHelpSlice.getIsFetchError();
  const helpFile = useHelpSlice.getHelpFile();
  const drawerSelectedHelpPage = useHeaderSlice.getNavRouteByLevel(3) || null;
  const modalSelectedHelpPage = useHeaderSlice.getCoreSelectedHelpPage();
  const selectedHelpPage = inNavDrawer ? drawerSelectedHelpPage : modalSelectedHelpPage;
  const currentLang = useSettingsSlice.currentLanguage();
  const isWideNav = ['de', 'da', 'nl'].includes(currentLang); // todo: get rid of this hardcode in the future 💩

  const isWideScreen = useIsLargerThanWide();
  const { fetchHelpFile, helpChapters, helpConfig } = useHelpFetcherConnected();

  const handleClick = (): void => {
    if (!helpFile) {
      fetchHelpFile();
    }
  };

  return (
    <ErrorBoundary fallback={<Loader />}>
      <PassiveComponentContext.Provider value={true}>
        {!helpFile ? (
          <HelpErrorMessage isError={isError} onClick={handleClick} />
        ) : (
          <ModalPages
            nav={({ onNavigation }): ReactNode =>
              !isWideScreen && selectedHelpPage ? null : (
                <HelpNavConnected
                  onNavigation={onNavigation}
                  helpChapters={helpChapters}
                  inNavDrawer={inNavDrawer}
                  selectedHelpPage={selectedHelpPage}
                />
              )
            }
            isNavHidden={!!selectedHelpPage}
            isWideNav={isWideNav}
          >
            {selectedHelpPage && <HelpPageConnected helpConfig={helpConfig} selectedHelpPage={selectedHelpPage} />}
          </ModalPages>
        )}
      </PassiveComponentContext.Provider>
    </ErrorBoundary>
  );
};
